import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { IAdminModalData } from '@modules/admin-panel/domain/models/admin-modal';
import { AdminResourcesService } from '@modules/admin-panel/services';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'app-admin-invite-user-modal',
	templateUrl: './admin-invite-user-modal.component.html',
	styleUrls: ['./admin-invite-user-modal.component.scss'],
})
export class AdminInviteUserModalComponent implements OnInit {
	@Input() data: IAdminModalData<{ resellerId: number }>;

	emailInputControl = new FormControl('', [Validators.required, Validators.email]);
	sendEmailControl = new FormControl(false);
	isLoading: boolean;
	inviteLink: string;

	constructor(private adminService: AdminResourcesService) {}

	ngOnInit(): void {}

	closeEvent(e?: {}): void {}

	sendInvite() {
		this.isLoading = true;
		const resellerId = this.data.options['node'].resellerId.toString();
		const email = this.emailInputControl.value;
		const sendEmail = this.sendEmailControl.value;

		this.adminService
			.inviteUser(resellerId, email, sendEmail)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe((res) => {
				this.inviteLink = res?.invite_link;
			});
	}
}
